var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlans01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plans") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.85,6.39V20.75A2.25,2.25,0,0,1,18.6,23H5.81a2.24,2.24,0,0,1-2.24-2.25V6.39A2.24,2.24,0,0,1,5.81,4.14h.9V5.71h11V4.14h.89A2.25,2.25,0,0,1,20.85,6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.71,3.36V5.71h-11V3.36a1.57,1.57,0,0,0,1.11-.47,1.52,1.52,0,0,0,.46-1.1V1h7.86v.79A1.57,1.57,0,0,0,17.71,3.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.43 11.15 8.48 12.2 10.05 10.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.06,
    y1: 11.41,
    x2: 16.99,
    y2: 11.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.43 15.27 8.48 16.32 10.05 14.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.06,
    y1: 15.54,
    x2: 16.99,
    y2: 15.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans01);
export default __webpack_public_path__ + "static/media/plans_01.51b055ecd4b0d5f7026fb494a08bd70b.svg";
export { ForwardRef as ReactComponent };